import VMenu from 'vuetify/es5/components/VMenu/VMenu';

/**
 * Extension del menu de Vuetify que permite fijarlo en la pantalla (position: fixed)
 */
export default {
  name: 'fixed-menu',
  extends: VMenu,
  methods: {
    getOffsetTop() {
      return 0;
    }
  },
  computed: {
    styles() {
      const self: any = this;
      return {
        maxHeight: self.calculatedMaxHeight,
        minWidth: self.calculatedMinWidth,
        maxWidth: self.calculatedMaxWidth,
        top: self.calculatedTop,
        left: self.calculatedLeft,
        transformOrigin: self.origin,
        zIndex: self.zIndex || self.activeZIndex,
        position: 'fixed'
      };
    }
  }
};
